import React, { Component } from 'react'

let dd = new Date()
let year = dd.getUTCFullYear()

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="pull-right hidden-print" style={{ height: '100%' }}>
          GPS Leaders &copy; All Rights Reserved { year }+
        </div>
        <div className="clearfix"></div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js